(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ekrano-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.ekranoReviewsReady === 'true') return;

      const track = section.querySelector('.ekrano-product-reviews__track');
      if (!track) return;

      section.dataset.ekranoReviewsReady = 'true';

      const previous = section.querySelector('[data-review-previous]');
      const next = section.querySelector('[data-review-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const updateControls = () => {
        if (previous) previous.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      const moveTrack = (direction) => {
        track.scrollBy({
          left: direction * track.clientWidth,
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      };

      previous?.addEventListener('click', () => moveTrack(-1));
      next?.addEventListener('click', () => moveTrack(1));
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);

      section.querySelectorAll('[data-review-expand]').forEach((button) => {
        button.addEventListener('click', () => {
          const comment = document.getElementById(button.getAttribute('aria-controls'));
          if (!comment) return;

          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          button.textContent = expanded ? 'Lire la suite' : 'Réduire';
          comment.classList.toggle('is-expanded', !expanded);
        });
      });

      updateControls();
    };

    const initializeWithin = (root) => {
      if (root.matches?.('[data-ekrano-product-reviews]')) initialize(root);
      root.querySelectorAll?.('[data-ekrano-product-reviews]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin(document));
    } else {
      initializeWithin(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
